import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import PostcodeAutocomplete from '../../js/components/autocomplete/postcode-autocomplete';
import { Input } from '../';
import { SuggestionListStyle, InputStyle } from './shared';

const renderInput = props => <Input {...props} />;
const Autocomplete = ({ className, ...rest }) => (
  <div className={className}>
    <PostcodeAutocomplete classPrefix={className} renderInputComponent={renderInput} {...rest} />
  </div>
);

Autocomplete.propTypes = {
  className: PropTypes.string.isRequired
};

const Styled = styled(Autocomplete)`
  width: 100%;

  &__suggestions-container {
    display: none;
  }

  &__container--open &__suggestions-container {
    ${SuggestionListStyle};
  }

  &__container--open &__suggestions-container {
    display: block;
  }

  &__input {
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      border-radius: 0;
    }
    ${InputStyle};
  }

  &__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      font-size: 14px;
    }
  }

  &__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    margin: 2px;
  }

  &__suggestion--focused {
    background-color: #eee;
    border-radius: 2px;
  }
`;

Styled.displayName = `LocationAutocomplete`;

export default Styled;
